import { render } from "./create-internal.vue?vue&type=template&id=775d5e0e&scoped=true&ts=true"
import script from "./create-internal.vue?vue&type=script&lang=ts"
export * from "./create-internal.vue?vue&type=script&lang=ts"

import "./create-internal.vue?vue&type=style&index=0&id=775d5e0e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775d5e0e"]])

export default __exports__